import { Fragment } from 'react';
import type { SubmitHandler } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { Typography } from '@/components/Typography';
import { messages } from '@/messages/notifyMe';
import { NewsLetterForm } from '@/views/NewsLetterView/NewsLetterForm';
import type { NewsLetterSchema } from '@/views/NewsLetterView/schema';

type NotifyMeFormProps = {
  caseMaterial: string;
  dialColor: string;
  handleSubmit: SubmitHandler<NewsLetterSchema>;
  productName: string;
};

export type ExtendedNewsLetterSchema = NewsLetterSchema & {
  currency: string;
  price: number;
  productName: string;
  productPath: string;
};

export type ExtendedSubmitHandler = SubmitHandler<ExtendedNewsLetterSchema>;

export const NotifyFormState = ({
  caseMaterial,
  dialColor,
  handleSubmit,
  productName,
}: NotifyMeFormProps) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Fragment>
        <Typography
          color='secondary'
          data-test-id='NotifyFormStateTypography1'
          fontWeight='regular'
          mt={4}
          scale='h5'
          textAlign='center'
          textTransform='uppercase'
        >
          {productName}
        </Typography>
        <Typography
          color='secondary'
          data-test-id='NotifyFormStateTypography2'
          fontWeight='regular'
          scale='h5'
          textAlign='center'
          textTransform='uppercase'
        >
          {caseMaterial} - {dialColor}
        </Typography>
        <Typography
          color='default'
          data-test-id='NotifyFormStateTypography3'
          mb={2}
          mt={1}
          textAlign='center'
        >
          {formatMessage(messages.firstToKnow)}
        </Typography>
        <NewsLetterForm
          data-test-id='NotifyFormStateNewsLetterForm'
          handleSubmit={handleSubmit}
          source='modal'
        ></NewsLetterForm>
      </Fragment>
    </>
  );
};
